import React from 'react'

export function Details({ connection }) {
  if (connection.is_connected === 'false') {
    return null
  }
  const connectionDatetime = new Date(connection.connected_on)
  return (
    <React.Fragment>
      <table className="mb-1 table text-nowrap">
        <tbody>
          <tr>
            <th scope="row" className='mr-0 col-md-1'>Connnected On:</th>
            <td>{connectionDatetime.toString()}</td>
          </tr>
          <tr>
            <th scope="row" className='mr-0 col-md-1'>Context ID:</th>
            <td>{connection.context_id}</td>
          </tr>
          <tr>
            <th scope="row" className='mr-0 col-md-1'>Context (Canvas Course) Title:</th>
            <td>{connection.context_title}</td>
          </tr>
          <tr>
            <th scope="row" className='mr-0 col-md-1'>Canvas Course (PK) ID:</th>
            <td>{connection.canvas_course_id}</td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  )
}
// TODO format date properly
